import axios from 'axios';
import API_BASE_URL from './api';

const API = `${API_BASE_URL}/api/admin/console`;
const cfg = { withCredentials: true };

export const listUsers = (search) => axios.get(`${API}/users`, { ...cfg, params: search ? { search } : {} }).then(r => r.data);
export const createUser = (payload) => axios.post(`${API}/users`, payload, cfg).then(r => r.data);
export const deleteUser = (id) => axios.delete(`${API}/users/${id}`, cfg).then(r => r.data);
export const forceLogoutUser = (id) => axios.post(`${API}/users/${id}/force-logout`, {}, cfg).then(r => r.data);
export const logoutAllOwn = () => axios.post(`${API}/logout-all`, {}, cfg).then(r => r.data);

export const listBlockedIps = () => axios.get(`${API}/blocked-ips`, cfg).then(r => r.data);
export const blockIp = (ip, reason) => axios.post(`${API}/blocked-ips`, { ip, reason }, cfg).then(r => r.data);
export const unblockIp = (ip) => axios.delete(`${API}/blocked-ips`, { ...cfg, params: { ip } }).then(r => r.data);

export const purge = (target, inactive_days) => axios.post(`${API}/purge`, { target, inactive_days }, cfg).then(r => r.data);

export const resetUserPassword = (userId, newPassword) => axios.post(`${API}/users/${userId}/reset-password`, newPassword ? { new_password: newPassword } : {}, cfg).then(r => r.data);

export const listDevices = (status) => axios.get(`${API}/devices`, { ...cfg, params: status ? { status } : {} }).then(r => r.data);
export const approveDevice = (id, days) => axios.post(`${API}/devices/${id}/approve`, {}, { ...cfg, params: (days ? { days } : {}) }).then(r => r.data);
export const rejectDevice = (id) => axios.post(`${API}/devices/${id}/reject`, {}, cfg).then(r => r.data);
export const deleteDevice = (id) => axios.delete(`${API}/devices/${id}`, cfg).then(r => r.data);
